// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
export type SharedListMemberFragment = { __typename?: 'SharedListMember', id: string, name: string, email?: string | null };

export type SharedListFragment = { __typename?: 'SharedList', listId: string, ownerName: string, ownerId: string, name: string, description?: string | null, lastUpdatedDate: number, createdDate: number, members?: Array<string> | null, invitations?: Array<string> | null, deadline?: number | null, coOwners?: Array<string> | null };

export const SharedListMemberFragmentDoc = gql`
    fragment SharedListMember on SharedListMember {
  id
  name
  email
}
    `;
export const SharedListFragmentDoc = gql`
    fragment SharedList on SharedList {
  listId
  ownerName
  ownerId
  name
  description
  lastUpdatedDate
  createdDate
  members
  invitations
  deadline
  coOwners
}
    `;